import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { DELETE_SYSTEM_BRAND_API, RETRIEVE_TENANT_BRANDS_SETTINGS_API, UPDATE_TENANT_BRAND_SETTINGS_API } from '../../api/api_data';
import { fail_retrieve_brands_settings, loading_retrieve_brands_settings, reset_retrieve_brands_settings, success_retrieve_brands_settings } from '../../reducers/auth_tenant/retrieve_brands_settings_Slice';
import { DELETE_TENANT_BRAND_ERROR_MSG, DELETE_TENANT_BRAND_SUCCESS_MSG, RETRIEVE_BRANDS_SETTINGS_ERROR_MSG, RETRIEVE_BRANDS_SETTINGS_SUCCESS_MSG, UPDATE_TENANT_BRAND_SETTINGS_ERROR_MSG, UPDATE_TENANT_BRAND_SETTINGS_SUCCESS_MSG } from '../../utils/error_success_messages';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { useSelector } from 'react-redux';
import * as app_consts from "../../utils/app_consts";
import { messageToast } from '../../utils/Utils';
import { Block, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { fail_update_tenant_brand_settings, loading_update_tenant_brand_settings, reset_update_tenant_brand_settings, success_update_tenant_brand_settings } from '../../reducers/auth_tenant/update_tenant_brand_settings_Slice';
import { fail_delete_tenant_brand, loading_delete_tenant_brand, reset_delete_tenant_brand, success_delete_tenant_brand } from '../../reducers/auth_tenant/delete_tenant_brand_Slice';
import YesNoModal from './YesNoModal';

const initial_state = { brand: "" };

const ViewBrandsSettingsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retrieved_data, setRetrievedData] = useState([]);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initial_state);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [sm, updateSm] = useState(false);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");
  const [delete_modal, setDeleteModal] = useState(false);
  const [selected_delete, setSelectedDelete] = useState("");
  const [delete_error, setDeleteError] = useState("");

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.settings?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    if (isOpen)
    {
      setFormData(initial_state);
      // Dispatch
      retrieve_brands_settings();
    }
    setOpen(isOpen);
  }, [isOpen]);

  const retrieve_brands_settings = () => {
    dispatch(tenant_auth_actions_helper(loading_retrieve_brands_settings, success_retrieve_brands_settings, fail_retrieve_brands_settings, RETRIEVE_BRANDS_SETTINGS_ERROR_MSG, RETRIEVE_BRANDS_SETTINGS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_BRANDS_SETTINGS_API}`));
  };

  // Listener
  const retrieve_brands_settings_listener = useSelector((state) => state.retrieve_brands_settings.retrieve_brands_settings);

  useEffect(() => {
    if (retrieve_brands_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_brands_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_brands_settings_listener.status === app_consts.FAIL)
        {
          setError(retrieve_brands_settings_listener.message);
          messageToast(retrieve_brands_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_brands_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_brands_settings_listener.data);
          setCurrentPageData(retrieve_brands_settings_listener.data);
        }
        dispatch(reset_retrieve_brands_settings());
      }
    }
  }, [retrieve_brands_settings_listener]);

  const handleAddBrand = () => {
    setUpdateError("");
    // Dispatch
    dispatch(tenant_auth_actions_helper(loading_update_tenant_brand_settings, success_update_tenant_brand_settings, fail_update_tenant_brand_settings, UPDATE_TENANT_BRAND_SETTINGS_ERROR_MSG, UPDATE_TENANT_BRAND_SETTINGS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_BRAND_SETTINGS_API}`, formData));
  };

  // Listener
  const update_tenant_brand_settings_listener = useSelector((state) => state.update_tenant_brand_settings.update_tenant_brand_settings);

  useEffect(() => {
    if (update_tenant_brand_settings_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_brand_settings_listener.status === app_consts.LOADING)
      {
        setUpdateError("");
      } else
      {
        setUpdateLoading(false);
        if (update_tenant_brand_settings_listener.status === app_consts.FAIL)
        {
          setUpdateError(update_tenant_brand_settings_listener.message);
          messageToast(update_tenant_brand_settings_listener.message, app_consts.FAIL);
        } else if (update_tenant_brand_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(UPDATE_TENANT_BRAND_SETTINGS_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_brands_settings();
          setFormData(initial_state);
        }
        dispatch(reset_update_tenant_brand_settings());
      }
    }
  }, [update_tenant_brand_settings_listener]);

  const open_delete_modal = (delete_item) => {
    setDeleteModal(true);
    setSelectedDelete(delete_item);
  };

  const close_delete_modal = () => {
    setDeleteModal(false);
    setSelectedDelete("");
  };

  const handle_delete_brand = () => {
    setDeleteError("");
    dispatch(tenant_auth_actions_helper(loading_delete_tenant_brand, success_delete_tenant_brand, fail_delete_tenant_brand, DELETE_TENANT_BRAND_ERROR_MSG, DELETE_TENANT_BRAND_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${DELETE_SYSTEM_BRAND_API}`, { brand: selected_delete }));
  };

  // Listener
  const delete_tenant_brand_listener = useSelector((state) => state.delete_tenant_brand.delete_tenant_brand);

  useEffect(() => {
    if (delete_tenant_brand_listener.status !== app_consts.IDLE)
    {
      if (delete_tenant_brand_listener.status === app_consts.LOADING)
      {
        setDeleteError("");
      } else
      {
        setUpdateLoading(false);
        if (delete_tenant_brand_listener.status === app_consts.FAIL)
        {
          setDeleteError(delete_tenant_brand_listener.message);
          messageToast(delete_tenant_brand_listener.message, app_consts.FAIL);
        } else if (delete_tenant_brand_listener.status === app_consts.SUCCESS)
        {
          messageToast(DELETE_TENANT_BRAND_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_brands_settings();
          setSelectedDelete("");
        }
        dispatch(reset_delete_tenant_brand());
      }
    }
  }, [delete_tenant_brand_listener]);


  return (
    <>
      <Modal isOpen={open} toggle={update_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"lg "}>
        <ModalHeader toggle={update_loading || loading ? "" : closeModal}>Brands</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieveing Brands Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        {update_error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {update_error}{" "}
                            </Alert>
                          </div>
                        )}
                        <TextInput
                          type="text"
                          id_val="brand"
                          value={formData?.brand}
                          colSize="6"
                          name="packet_size"
                          handleChange={(e) => setFormData({ ...formData, brand: e.target.value })}
                        />
                        <Col lg="4" className="d-flex justify-content-start">
                          <Button onClick={handleAddBrand} disabled={
                            (update_loading) ||
                            !(formData?.brand)
                          } color="primary">
                            {update_loading ? <Spinner size="sm" color="light" /> : "Add"}
                          </Button>
                        </Col>
                      </Row>
                      <Block>
                        <div className="nk-tb-list is-separate is-medium my-4">
                          <DataTableHead className="nk-tb-item">
                            <DataTableRow>
                              <span className="sub-text">Brand Name</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="sub-text"></span>
                            </DataTableRow>
                          </DataTableHead>
                          {currentItems?.length > 0
                            ? currentItems?.map((item) => (
                              <DataTableItem key={item.id}>
                                <DataTableRow>
                                  <div className="user-card">
                                    <div className="user-info">
                                      <span className="tb-lead">
                                        {item || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                      </span>
                                    </div>
                                  </div>
                                </DataTableRow>
                                <DataTableRow>
                                  <Icon name="trash-fill" className="text-danger" style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => open_delete_modal(item)}></Icon>
                                </DataTableRow>
                              </DataTableItem>
                            ))
                            : <div className="ms-2">No Brands found</div>}
                        </div>
                        {currentItems?.length > 0 && (
                          <div className="mt-3">
                            <PaginationComponent
                              itemPerPage={itemPerPage}
                              totalItems={current_page_data?.settings?.length}
                              paginate={paginate}
                              currentPage={currentPage}
                            />
                          </div>
                        )}
                      </Block>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>

      <YesNoModal openModal={delete_modal} setOpenModal={setDeleteModal} modalTitle={`Remove ${selected_delete} ?`} errAmend={delete_error} setErrAmend={setDeleteError} buttonCancel="No" buttonConfirm="Yes" modalDescription={`Are you Sure that you want to Delete ${selected_delete} from System Brands?`} succFunc={handle_delete_brand} />
    </>
  );
};

export default ViewBrandsSettingsModal;